export default __webpack_public_path__ + "static/media/OnlineOrder-100k.0d7c3128.png";